<template>
  <div id="app" v-cloak>


      <h-header v-if="isMobile == true"></h-header>
      <v-header v-else></v-header>
        <router-view/>
      <h-footer v-if="isMobile == true"></h-footer>
      <v-footer v-else></v-footer>

  </div>
</template>

<script>
import vHeader from '@/components/Header.vue'
import vFooter from '@/components/Footer.vue'
import hHeader from '@/components/H5Header.vue'
import hFooter from '@/components/H5Footer.vue'

export default {
  name: 'App',
  data(){
        return{
            isMobile: false
        }
  },
  components: {
    vHeader,
    vFooter,
    hHeader,
    hFooter
  },
  created(){
    let flag = this._isMobile();
    if(flag != null){
      console.log("移动端")
      this.isMobile = true
    } else {
      console.log("pc端")
      this.isMobile = false
    }
    // console.log(flag);
  },
  methods: {
    _isMobile: function() {
      let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  },
  watch:{
    $route() {   
        // 回到顶部
      window.scrollTo(0, 0);
    }
  }
}
</script>

<style>
#app {
  
}
</style>



// WEBPACK FOOTER //
// src/App.vue